import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ReactEcharts from "echarts-for-react";
import "echarts-gl";
import PageHeader from "../../components/PageHeader";
import { topTypesOption, topBranchesOption, sparkleCardData } from "../../Data/DashbordData";
import SparkleCard from "../../components/SparkleCard";
import { setupDatas, sparks, topBranches, topTypes } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import LastServicesTable from "../../components/Tables/LastServicesTable";
import SetupInfoCard from "../../components/Pages/SetupInfoCard";
import "./Dashboard.css";

class Dashbord extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardData: [],
      topTypesOption: {},
      topTypesCheck: [],
      topBranchesOption: {},
      topBranchesCheck: [],
      isLoad: true,
      setupInfo: {},
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.isLoggedin) {
      this.fetchDatas();
    }
  }

  fetchDatas = async () => {
    try {
      const [sparksData, topTypesData, topBranchesData, setupDatasResult] = await Promise.all([
        sparks(),
        topTypes(),
        topBranches(),
        setupDatas(),
      ]);

      this.setState({
        cardData: sparkleCardData(sparksData[0]),
        topTypesOption: topTypesOption(topTypesData),
        topBranchesOption: topBranchesOption(topBranchesData),
        setupInfo: setupDatasResult || {},
        topTypesCheck: topTypesData,
        topBranchesCheck: topBranchesData,
        isLoad: false,
      });
    } catch (error) {
      this.setState({ isLoad: false });
      console.error('Error fetching dashboard data:', error);
    }
  };

  renderPanelState = (message, icon = 'fa-lock') => (
    <div className="dz-empty-state">
      <i className={`fa ${icon}`} />
      <strong>{message}</strong>
    </div>
  );

  render() {
    const { userPermissions } = this.props;
    const { cardData, isLoad, topTypesOption: typesChart, topBranchesOption: branchesChart, setupInfo, topTypesCheck, topBranchesCheck } = this.state;
    const hasViewCardsPermission = userPermissions.includes('view cards');
    const hasViewChartPermission = userPermissions.includes('view charts');
    const hasViewServiceTable = userPermissions.includes('view last service table');
    const canCreateService = userPermissions.includes('new service');
    const canViewServices = userPermissions.includes('view menu services');
    const canViewReports = userPermissions.includes('view menu reports');
    const setupReady = setupInfo.branches > 0
      && setupInfo.types > 0
      && setupInfo.status > 2
      && setupInfo.business
      && setupInfo.notification;
    const today = new Intl.DateTimeFormat('tr-TR', {
      weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
    }).format(new Date());

    return (
      <div className="dz-dashboard" onClick={() => document.body.classList.remove("offcanvas-active")}>
        <div className="container-fluid">
          <PageHeader HeaderText="Dashboard" Breadcrumb={[{ name: "Dashboard" }]} />

          <div className="page-loader-wrapper" style={{ display: isLoad ? 'block' : 'none' }}>
            <div className="loader dz-page-loader">
              <img src={require('../../assets/images/logo-white.png')} width="150" alt="ServiceZone" />
              <p>Dashboard hazırlanıyor</p>
              <ReactLoading type="spin" width="24px" height="24px" color="#ffffff" />
            </div>
          </div>

          <section className="dz-hero">
            <div className="dz-hero-copy">
              <span className="dz-eyebrow"><i className="fa fa-circle" /> OPERASYON MERKEZİ</span>
              <h1>İşletmenize genel bakış</h1>
              <p>{today.charAt(0).toLocaleUpperCase('tr-TR') + today.slice(1)} · Güncel servis ve gelir hareketleri</p>
            </div>
            <div className="dz-quick-actions">
              {canCreateService && <Link className="primary" to="/service-add-ai"><i className="fa fa-plus" /><span>Yeni servis</span></Link>}
              {canViewServices && <Link to="/services"><i className="fa fa-wrench" /><span>Servisler</span></Link>}
              {canViewReports && <Link to="/reports-center"><i className="fa fa-line-chart" /><span>Rapor merkezi</span></Link>}
            </div>
          </section>

          {!isLoad && Object.keys(setupInfo).length > 0 && !setupReady && (
            <SetupInfoCard setupInfo={setupInfo} />
          )}

          <section className="dz-section">
            <div className="dz-section-heading">
              <div><span>BUGÜNÜN NABZI</span><h2>Temel göstergeler</h2><p>Son yedi güne göre işletmenizin güncel hareketi.</p></div>
            </div>
            {isLoad ? (
              <div className="dz-loading-card"><ReactLoading type="spin" width="26px" height="26px" color="#2f6fed" /><span>Kartlar hazırlanıyor...</span></div>
            ) : hasViewCardsPermission ? (
              <div className="dz-kpi-grid">
                {cardData.map((data, index) => (
                  <SparkleCard
                    index={index}
                    key={data.heading}
                    Heading={data.heading}
                    Money={data.money}
                    PerText={data.perText}
                    mainData={data.sparklineData.data}
                    chartColor={data.sparklineData.areaStyle.color}
                    ContainerClass="dz-kpi-column"
                    variant="dashboard"
                  />
                ))}
              </div>
            ) : this.renderPanelState('Gösterge kartlarını görüntüleme yetkiniz bulunmuyor.')}
          </section>

          <section className="dz-section">
            <div className="dz-section-heading">
              <div><span>PERFORMANS</span><h2>Gelir dağılımı</h2><p>Servis tipi ve şube bazında gelir eğilimlerini karşılaştırın.</p></div>
              <span className="dz-period-badge"><i className="fa fa-calendar-o" /> Aylık görünüm</span>
            </div>
            <div className="dz-chart-grid">
              <article className="dz-panel dz-chart-panel">
                <div className="dz-panel-heading"><span className="blue"><i className="fa fa-pie-chart" /></span><div><small>SERVİS KIRILIMI</small><h3>Servis tiplerine göre gelir</h3></div></div>
                {isLoad ? (
                  <div className="dz-chart-loading"><ReactLoading type="spin" width="25px" height="25px" color="#2f6fed" /></div>
                ) : hasViewChartPermission ? (
                  topTypesCheck.length > 0
                    ? <ReactEcharts option={typesChart} opts={{ renderer: "svg" }} style={{ height: 310 }} />
                    : this.renderPanelState('Bu dönem için servis tipi verisi bulunmuyor.', 'fa-bar-chart')
                ) : this.renderPanelState('Grafikleri görüntüleme yetkiniz bulunmuyor.')}
              </article>

              <article className="dz-panel dz-chart-panel">
                <div className="dz-panel-heading"><span className="green"><i className="fa fa-building-o" /></span><div><small>ŞUBE KIRILIMI</small><h3>Şubelere göre gelir</h3></div></div>
                {isLoad ? (
                  <div className="dz-chart-loading"><ReactLoading type="spin" width="25px" height="25px" color="#2f6fed" /></div>
                ) : hasViewChartPermission ? (
                  topBranchesCheck.length > 0
                    ? <ReactEcharts option={branchesChart} opts={{ renderer: "svg" }} style={{ height: 310 }} />
                    : this.renderPanelState('Bu dönem için şube verisi bulunmuyor.', 'fa-bar-chart')
                ) : this.renderPanelState('Grafikleri görüntüleme yetkiniz bulunmuyor.')}
              </article>
            </div>
          </section>

          <section className="dz-panel dz-services-panel">
            <div className="dz-section-heading">
              <div><span>SON HAREKETLER</span><h2>Son eklenen araç servisleri</h2><p>Yeni açılan servis kayıtlarını hızlıca görüntüleyin ve yönetin.</p></div>
              {canViewServices && <Link className="dz-all-link" to="/services">Tüm servisler <i className="fa fa-arrow-right" /></Link>}
            </div>
            {isLoad ? (
              <div className="dz-loading-card compact"><ReactLoading type="spin" width="25px" height="25px" color="#2f6fed" /><span>Servisler hazırlanıyor...</span></div>
            ) : hasViewServiceTable ? (
              <div className="dz-table-wrap"><LastServicesTable /></div>
            ) : this.renderPanelState('Son servis kayıtlarını görüntüleme yetkiniz bulunmuyor.')}
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ loginReducer }) => ({
  isLoggedin: loginReducer.isLoggedin,
});

export default withPermissions(connect(mapStateToProps)(Dashbord));
